export default __webpack_public_path__ + "8bdabe6a0bfeea88089f284b03544694.glb";